class RockObject {
  #dictionary = null;
  constructor(targetLanguage, dictionary, rock, sourceLanguage = null) {
    (this.targetLanguage = targetLanguage),
      (this.#dictionary = dictionary),
      (this.sourceLanguage = sourceLanguage),
      (this.idName = this.#removeAccent(rock.name)),
      (this.name =
        this.targetLanguage === "en"
          ? { propName: "name", propValue: rock.name }
          : { propName: "nome", propValue: rock.pt_name }),
      (this.type =
        this.targetLanguage === "en"
          ? { propName: "type", propValue: `${rock.type} rock` }
          : {
              propName: "tipo",
              propValue: `rocha ${this.#dictionary[rock.type]}`,
            }),
      (this.composition =
        this.targetLanguage === "en"
          ? "minerals & other"
          : "minerais e outros"),
      (this.composition_essential =
        this.targetLanguage === "en"
          ? { propName: "essential", propValue: rock.mineral_essential }
          : {
              propName: "essenciais",
              propValue: this.#adjustEssentialMinerals(
                this.#translateString(rock.mineral_essential),
              ),
            }),
      (this.composition_additional =
        this.targetLanguage === "en"
          ? { propName: "other", propValue: rock.mineral_additional }
          : {
              propName: "acessórios",
              propValue: this.#breakAdditionalMineral(
                this.#translateString(rock.mineral_additional),
              ),
            }),
      (this.composition_other =
        this.targetLanguage === "en"
          ? { propName: "+", propValue: rock.mineral_other }
          : {
              propName: "+",
              propValue: this.#breakOtherMineral(
                this.#translateString(rock.mineral_other),
              ),
            });
    this.img = {
      author: rock.img_author,
      author_url: rock.img_aut_url,
      license: rock.img_license,
      url: rock.img_url,
      alt: rock.img_alt,
    };
    this.grain = {
      propName: this.targetLanguage === "en" ? "grain size" : "grãos",
      min: rock.grain_min > 0 ? rock.grain_min : null,
      max: rock.grain_max,
      other:
        this.targetLanguage === "en"
          ? rock.grain_other
          : this.#adjustGrains(this.#translateString(rock.grain_other)),
    };
    this.characteristics =
      this.targetLanguage === "en"
        ? { propName: "characteristics", propValue: rock.classification }
        : {
            propName: "características",
            propValue: this.#adjustOrigin(
              this.#translateString(rock.classification),
            ),
          };
    this.neworigin =
      this.targetLanguage === "en"
        ? {
            propName: "characteristics",
            propValue: this.#breakOrigin(rock.classification),
          }
        : {
            propName: "características",
            propValue: this.#translatebreakOrigin(
              this.#breakOrigin(rock.classification),
            ),
          };
  }

  #breakOrigin(str) {
    if (str === null || str === undefined) return;
    let stringArray;
    str.includes(";")
      ? (stringArray = str.split(/;\s/gm))
      : (stringArray = [str]);

    let newStringArray;

    newStringArray = stringArray.map((s) => s.split(/:\s/g));
    const entries = new Map(newStringArray);
    const obj = Object.fromEntries(entries);
    return obj;
  }

  #translatebreakOrigin(obj) {
    if (obj === undefined) return;
    let newObj = {};
    for (const [key, value] of Object.entries(obj)) {
      const newKey = this.#translateString(key);
      let newValue;
      // adjust gender in portuguese (temperatura: baixa)
      const regex = /(pressure|temperature)/g;
      regex.test(key)
        ? (newValue = this.#translateString(value).replace(/o\b/g, "a"))
        : (newValue = this.#adjustOrigin(this.#translateString(value)));

      newObj[newKey] = newValue;
    }

    return newObj;
  }
  /**
   *
   * @param {String} str word with accent
   * @returns word without accent, apostrophe, or hiphen, e
   */
  #removeAccent(str) {
    return str
      .normalize("NFD")
      .replace(/([\u0300-\u036f]|[^a-zA-Z])|\W/g, "")
      .toLowerCase();
  }

  #translateString(originalString) {
    if (!originalString) {
      return;
    }
    const stringConvertedToLowercase = originalString.toLowerCase();
    const eachWord = /\b[a-z]+\b/gi;
    const dictEntries = [...stringConvertedToLowercase.matchAll(eachWord)];
    const translatedString = dictEntries.reduce((total, word) => {
      return (total = total.replace(word, this.#dictionary[word]));
    }, stringConvertedToLowercase);
    return translatedString;
  }

  // using regex to adjust the translation of essential minerals
  #adjustEssentialMinerals(stringEM) {
    const regexClay = [/(argila)\s(minerais)/g, "$2 de $1"];
    const regexIron = [/(ferro)\s(minerais)/g, "$2 de $1"];
    const regexPhosphate = [/(fosfato)\s(minerais)/g, "$2 de $1"];
    const regexPotassium = [/(potássio)\s(minerais)/g, "$2 de $1"];
    const regexFeldspar = [/(alcalino)\s(feldspato)/g, "$2 $1"];

    let originalString = stringEM;

    function replaceString(prior, current) {
      if (prior.test(originalString)) {
        originalString = originalString.replace(prior, current);
      }
    }

    replaceString(regexClay[0], regexClay[1]);
    replaceString(regexIron[0], regexClay[1]);
    replaceString(regexPhosphate[0], regexPhosphate[1]);
    replaceString(regexPotassium[0], regexPotassium[1]);
    replaceString(regexFeldspar[0], regexFeldspar[1]);

    return originalString;
  }

  // Additional Minerals
  #breakAdditionalMineral(stringAM) {
    if (/,/.test(stringAM)) {
      return stringAM
        .split(", ")
        .map((stringB) => this.#adjustAdditionalMinerals(stringB))
        .join(", ");
    } else {
      return this.#adjustAdditionalMinerals(stringAM);
    }
  }

  // using regex to adjust the translation of additional minerals
  #adjustAdditionalMinerals(stringAM) {
    const regexFenocristal = [
      /(\w[a-zÀ-ÿ]+)\s(fenocristais|minerais)/g,
      "$2 de $1",
    ];
    const regexPesadoResistente = [
      /(pesado)\se\s(resistente)\s(minera[l|i]s?)/g,
      "$3 $2 e $1",
    ];
    const regexPesadoMineral = [/(pesados?)\s(minera[l|i]s?)/g, "$2 $1" + "s"];
    const regexTerraRara = [
      /(rara)-(terra)\s(minera[l|i]s?)/g,
      "$3 de $2s $1s",
    ];
    const regexOxido = [
      /(\w[a-zÀ-ÿ]+)\s(óxido)\s(minera[l|i]s?)/g,
      "$3 de $2 de $1",
    ];
    const metamorfica = [
      /térmico\smetamórfica\sminerais/g,
      "minerais de metamorfismo térmico",
    ];
    const regexRich = [/(\w+)-(rico)\s(\w[a-zÀ-ÿ]+)/g, "$3 $2 em $1"];

    let originalString = stringAM;

    function replaceString(prior, current) {
      if (prior.test(originalString)) {
        originalString = originalString.replace(prior, current);
      }
    }

    replaceString(metamorfica[0], metamorfica[1]);
    replaceString(regexOxido[0], regexOxido[1]);
    replaceString(regexPesadoResistente[0], regexPesadoResistente[1]);
    replaceString(regexPesadoMineral[0], regexPesadoMineral[1]);
    replaceString(regexTerraRara[0], regexTerraRara[1]);
    replaceString(regexRich[0], regexRich[1]);
    replaceString(regexFenocristal[0], regexFenocristal[1]);
    return originalString;
  }
  //other mineral
  #breakOtherMineral(stringOM) {
    if (/,/g.test(stringOM)) {
      return stringOM
        .split(", ")
        .map((stringO) => this.#adjustOtherMineral(stringO))
        .join(", ");
    } else {
      return this.#adjustOtherMineral(stringOM);
    }
  }

  // regex to adjust translation of other minerals
  #adjustOtherMineral(stringOM) {
    const regexFragmento = /(fragmentos?)/g;
    const regexFossil = /(planta)\s(fóssil)/g;
    const regexVidroRocha =
      /vidro|(ígnea|country|adjacentes?)\srochas?|lava|grão|clastos?|material|sediment/g;
    const regexFenocristal = /(\w[a-zÀ-ÿ]+)\s(fenocristais|minerais)/g;

    let originalString = stringOM;
    if (regexFragmento.test(originalString)) {
      return originalString
        .split(" ")
        .reverse()
        .join(" ")
        .replace(regexFragmento, "$1 de");
    }
    if (regexVidroRocha.test(originalString)) {
      return originalString.split(" ").reverse().join(" ");
    }
    if (regexFossil.test(originalString)) {
      return originalString.replace(regexFossil, "$2 de $1");
    }
    if (regexFenocristal.test(originalString)) {
      return originalString.replace(regexFenocristal, "$2 de $1");
    }
    return originalString;
  }

  // using regex to adjust the translation of grains
  #adjustGrains(stringG) {
    const matriz = [/fino\smatriz/g, "matriz fina"];

    let originalString = stringG;

    function replaceString(prior, current) {
      if (prior.test(originalString)) {
        originalString = originalString.replace(prior, current);
      }
    }

    replaceString(matriz[0], matriz[1]);

    return originalString;
  }

  // adjust origin translation
  #adjustOrigin(stringO) {
    let originalString = stringO;

    const regexMaterial = /(\w+)\s(material)/g;
    const regexMagma = /(básico)\s(magma)/g;
    const regexQuente = /(quente)\s(água)/g;
    const regexSuave = /(suave)\s(corrente)/g;
    const regexIgnea = /(ígnea)\s(rocha)/g;
    const regexOrganico = /(orgânico)\s(detrito)/g;

    const volcanic = [/(vulcânico)\s(áreas)/g, "áreas vulcânicas"];
    const lowGrade = [/(grau):\s(baixa)/g, "grau: baixo"];
    const highTemperature = [/(temperatura):\s(alto)/g, "temperatura: alta"];
    const veryLowGrade = [/muia\sbaixo\sto\sbaixo/g, "muito baixo a baixo"];
    const ouigem = [/(ouigem)/g, "origem"];
    const turbidez = [/(turbidez)\s(corrente)/g, "corrente de turbidez"];
    const corrente = [/forte\ságua\scorrente/g, "corrente forte de água"];
    const sedimentos = [
      /fino-de\sgrãos\ssedimentos/,
      "sedimentos de grãos finos",
    ];
    const rico = [/(quartzo)-(rico)\s(sedimentos|arenito)/g, "$3 $2 em $1"];
    const into = [/no\sundefined/g, "no"];
    const fragment = [/(rocha)\s(fragmento)/g, "$2 de $1"];
    const extrusiva = [/extrusiva\sou\svulcânico/g, "extrusiva ou vulcânica"];
    const vento = [/(vento)-(depositado)\s(sedimentos)/g, "$3 $2s pelo $1"];

    function reverse(regexTest, stringTest) {
      if (regexTest.test(stringTest)) {
        stringTest = stringTest.replace(regexTest, "$2 $1");
      }
      originalString = stringTest;
    }

    function replaceString(prior, current) {
      if (prior.test(originalString)) {
        originalString = originalString.replace(prior, current);
      }
    }

    reverse(regexMaterial, originalString);
    reverse(regexMagma, originalString);
    reverse(regexQuente, originalString);
    reverse(regexSuave, originalString);
    reverse(regexIgnea, originalString);
    reverse(regexOrganico, originalString);

    replaceString(volcanic[0], volcanic[1]);
    replaceString(lowGrade[0], lowGrade[1]);
    replaceString(highTemperature[0], highTemperature[1]);
    replaceString(veryLowGrade[0], veryLowGrade[1]);
    replaceString(ouigem[0], ouigem[1]);
    replaceString(turbidez[0], turbidez[1]);
    replaceString(corrente[0], corrente[1]);
    replaceString(sedimentos[0], sedimentos[1]);
    replaceString(rico[0], rico[1]);
    replaceString(into[0], into[1]);
    replaceString(fragment[0], fragment[1]);
    replaceString(extrusiva[0], extrusiva[1]);
    replaceString(vento[0], vento[1]);

    return originalString;
  }
}

export { RockObject };
